import { createContext, useContext } from "react";
import { User } from "firebase/auth";

export interface AuthContextType {
  user: User | null | undefined;
  isLoading: boolean;
}

export const AuthContext = createContext<AuthContextType>({
  user: undefined,
  isLoading: true,
});

export const useAuth = () => useContext(AuthContext);
